<template>
  <div class="myself">
    <el-row :gutter="20">
      <el-col :span="24" style="text-align: left;padding: 10px 20px;font-size: 20px; font-weight: 700;">关于我</el-col>
    </el-row>
    <el-row>
      <!-- <el-col :span="24" style="display: flex;"> -->
       <!-- <el-image
         src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fc-ssl.duitang.com%2Fuploads%2Fitem%2F202003%2F12%2F20200312235222_LnUAs.thumb.400_0.jpeg&refer=http%3A%2F%2Fc-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1651126298&t=284d0b373966420db5f419666da38565"
         fit="contain"
         style="width: 200px;height: 100px;"
        ></el-image> -->
          <img :src="avatar" alt="" style="width: 100px;height: 100px;float: left;" hspace="10"/>
        <p style="text-indent: 2em;text-align: left;word-break: break-all;">
           {{desc}}
         </p>
      <!-- </el-col> -->
    </el-row>
  </div>
</template>

<script>
  export default{
    name:'Myself',
    data(){
      return {
        avatar:'',
        desc:''
      }
    },
    mounted() {
      this.getUser()
    },
    methods:{
      async getUser(){
        const timestamp = Date.now()
        const res = await this.$api.getUserInfo({t:'json',timestamp})
        if(res.code == 200){
          this.avatar = res.data.url
          this.desc = res.data.desc
        }else{
          console.log('error')
        }
      }
    }
  }
</script>

<style>
  .myself{
    background-color: #fff;
    padding: 10px 20px;
    border-radius: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Myself.vue